import { useAppKit } from "@reown/appkit/react";
import React from "react";
import { FiLogOut } from "react-icons/fi";
import SafeIcon from "../common/SafeIcon";
import { useAuth } from "../contexts/AuthContext";

const WalletConnect = ({ variant = "primary", className = "", style = {} }) => {
  const { logout, isAuthenticated, walletAddress, signIn } = useAuth();
  const { open } = useAppKit();

  const handleConnect = () => {
    // Use signIn from AuthContext which marks connection as user-initiated
    signIn();
  };

  const handleDisconnect = () => {
    logout();
  };

  // Format wallet address for display
  const formatAddress = (address) => {
    if (!address) return "";
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  const baseClasses =
    "inline-flex items-center px-6 py-3 rounded-lg font-medium transition-all duration-200 disabled:opacity-50";
  const variants = {
    primary:
      "glass-orange text-orange-400 hover:text-orange-300 border border-orange-500/50 hover:border-orange-400/70 shadow-glow-orange-sm hover:shadow-glow-orange",
    secondary:
      "glass text-white hover:text-orange-400 border border-white/20 hover:border-orange-500/50",
  };

  if (isAuthenticated && walletAddress) {
    return (
      <button
        onClick={handleDisconnect}
        className={`${baseClasses} ${variants[variant]} ${className}`}
        style={style}
      >
        <div className="w-2 h-2 bg-orange-500 rounded-full mr-2 animate-pulse-glow" />
        <span className="font-mono text-sm">
          {formatAddress(walletAddress)}
        </span>
        <SafeIcon icon={FiLogOut} className="ml-2" />
      </button>
    );
  }

  return (
    <button
      onClick={handleConnect}
      className={`${baseClasses} ${variants[variant]} ${className}`}
      style={style}
    >
      Connect Wallet
    </button>
  );
};

export default WalletConnect;
